import { lisbonDateTimeInput, lisbonInputToIso } from '../../shared/lisbonTime'
import type { FormField } from '../types'

export function formDefaults(fields: FormField[], initialValues?: Record<string, unknown> | null) {
  return Object.fromEntries(fields.map((field) => {
    const provided = initialValues?.[field.key]
    if (field.timeZone && field.type === 'datetime-local') return [field.key, lisbonDateTimeInput(provided)]
    if (provided !== undefined && provided !== null) return [field.key, Array.isArray(provided)
      ? provided.map((item) => typeof item === 'object' && item && 'name' in item ? String(item.name) : String(item)).join(', ')
      : provided]
    if (field.type === 'checkbox') return [field.key, field.key === 'active']
    if (field.type === 'select' && !initialValues) return [field.key, field.required ? field.options?.[0]?.value ?? '' : '']
    return [field.key, '']
  }))
}

export function formPayload(fields: FormField[], values: Record<string, unknown>, initialValues?: Record<string, unknown> | null) {
  const cleaned = Object.fromEntries(fields.map((field) => {
    const value = values[field.key]
    if (field.type === 'number') return [field.key, value === '' ? null : Number(value)]
    if (field.type === 'datetime-local' && field.timeZone) return [field.key, lisbonInputToIso(String(value || ''), initialValues?.[field.key])]
    return [field.key, value]
  }))
  if (fields.some((field) => field.key === 'start' && field.timeZone) && cleaned.start && cleaned.end && Date.parse(String(cleaned.end)) <= Date.parse(String(cleaned.start))) {
    throw new Error('Scheduled end must be after scheduled start.')
  }
  return cleaned
}
